import { Component } from '@angular/core';
import { DataServiceService } from '../helpers/data.service';
import { ConfigService } from '../helpers/config.service';

@Component({
    selector: 'app-dv',
    templateUrl: './dv.component.html',
    styleUrl: './dv.component.scss',
    standalone: false
})
export class DvComponent {
  csData:any = {};
  showCsData:boolean = true;
  constructor(public data:DataServiceService, public cs: ConfigService){
    this.data.setIsCouponLastStep(false);
    this.data.setHeaderMenuSelection('5');
  }

  async ngOnInit(): Promise<void> {
    this.csData = {};
    this.showCsData = true;
    await this.cs.getConfigurations('dv360', 'en');
    this.data.setCsObj(this.cs);
    this.csData = this.cs;
    setTimeout(() => {
      this.showCsData = false;
  }, 100);
  }
}
